import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import dayjs from "dayjs";

dayjs.locale("pt-br");

const ResumoContaFinanceira = (props: any) => {
  return (
    <table>
      <tbody>
        <tr>
          <td>Empresa:</td>
          <td>{props.contaFinanceira.empresa || "-"}</td>
        </tr>
        <tr>
          <td>Conta Bancária:</td>
          <td>{props.contaFinanceira.denominacaoContaBancoUsuario || "-"}</td>
        </tr>
        <tr>
          <td>Fornecedor:</td>
          <td>{props.contaFinanceira.razaoPessoa || "-"}</td>
        </tr>
        <tr>
          <td>Favorecido:</td>
          <td>{props.contaFinanceira.razaoFavorecido || "-"}</td>
        </tr>
        <tr>
          <td> &nbsp;</td>
        </tr>
        <tr>
          <td>Data de Emissão:</td>
          <td>{props.contaFinanceira.dataEmissao ? dayjs(props.contaFinanceira.dataEmissao).format("DD/MM/YYYY") : "-"}</td>
        </tr>
        <tr>
          <td>Data de Vencimento:</td>
          <td>{props.contaFinanceira.dataVencimento ? dayjs(props.contaFinanceira.dataVencimento).format("DD/MM/YYYY") : "-"}</td>
        </tr>
        <tr>
          <td>Data de Competência:</td>
          <td>{props.contaFinanceira.dataCompetencia ? dayjs(props.contaFinanceira.dataCompetencia).format("MM/YYYY") : "-"}</td>
        </tr>
        <tr>
          <td>Número do Documento:</td>
          <td>{props.contaFinanceira.numeroDocumento || "-"}</td>
        </tr>
        <tr>
          <td> &nbsp;</td>
        </tr>
        <tr>
          <td>Valor Bruto:</td>
          <td>{props.contaFinanceira.valorBruto ? currencyBRL(props.contaFinanceira.valorBruto) : currencyBRL(0)}</td>
        </tr>
        <tr>
          <td>Valor Líquid:o</td>
          <td>{props.contaFinanceira.valorLiquido ? currencyBRL(props.contaFinanceira.valorLiquido) : currencyBRL(0)}</td>
        </tr>
        <tr>
          <td>Valor Pago:</td>
          <td>{props.contaFinanceira.valorPago ? currencyBRL(props.contaFinanceira.valorPago) : currencyBRL(0)}</td>
        </tr>

        <tr>
          <td>Saldo a Pagar:</td>
          <td>{props.contaFinanceira.saldoPagar ? currencyBRL(props.contaFinanceira.saldoPagar) : currencyBRL(0)}</td>
        </tr>

        <tr>
          <td> &nbsp;</td>
        </tr>
        <tr>
          <td>Auditoria:</td>
          <td>{props.contaFinanceira.denominacaoStatusAuditoria || "-"}</td>
        </tr>
        <tr>
          <td>Status:</td>
          <td>{props.contaFinanceira.situacaoConta || "-"}</td>
        </tr>
        <tr>
          <td> &nbsp;</td>
        </tr>
        <tr>
          <td>Histórico:</td>
          <td>{props.contaFinanceira.historico || "-"}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default ResumoContaFinanceira;
